/**
 * Module finance — généré depuis le plan directeur GÉCÉRAM CRM (2026-07-28).
 * S'intègre par le registre : aucun fichier du noyau modifié.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "finance",
  label: "Finance",
  icon: "i-euro",
  navGroup: "finance",
  navOrder: 50,
  rolesRequis: ["admin", "secretariat", "comptabilite"],
  routes: [{ path: "/finance", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
